import React from "react";
import { Alert, Snackbar } from "@mui/material";

/* 
This component will accept props such as message,severity,open and a callback for onClose
*/
export default function MessageSnackbar({
	message,
	severity = "info",
	open,
	onClose,
	autoHideDuration = 5000,
	sx = {},
}) {
	return (
		<Snackbar
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			open={open}
			autoHideDuration={autoHideDuration}
			onClose={onClose}
			sx={sx}
		>
			<Alert
				onClose={onClose}
				severity={severity}
				sx={{ width: "100%", ...sx }}
			>
				{typeof message === "object" ? "Successful" : message}
			</Alert>
		</Snackbar>
	);
}
